module.exports = __webpack_public_path__ + "img/visa.44ba0f62.svg";